import { Box, Text } from '@wix/design-system';
import classNames from 'classnames';
import React from 'react';
import { AI_RECOMMENDED_FOR_NAME_TRANSLATION_KEY, AI_RECOMMENDED_FOR_SITE_TRANSLATION_KEY } from '../../utils';
import { useEclipsePlanRecommendation } from '../../hooks/useEclipsePlanRecommendation';
import { useCurrentModule } from '../ModuleProvider';
import { SparkleIcon } from '../SparkleIcon';
import s from './AiRecommendedHat.scss';
export const AI_HAT_SHIMMER_MS = 2000;
const AI_HAT_BACKGROUND = '#efedfe';
export const AiRecommendedHat = _ref => {
  let {
    productId
  } = _ref;
  const module = useCurrentModule();
  const {
    t
  } = module.internals.useTranslations();
  const {
    data: product
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchProduct({
    productId
  });
  const {
    siteName
  } = useEclipsePlanRecommendation();
  const [isSettled, setIsSettled] = React.useState(false);
  React.useEffect(() => {
    const timer = setTimeout(() => setIsSettled(true), AI_HAT_SHIMMER_MS);
    return () => clearTimeout(timer);
  }, []);
  const planName = (product == null ? void 0 : product.name) ?? '';
  const text = siteName ? t(AI_RECOMMENDED_FOR_NAME_TRANSLATION_KEY, {
    planName,
    siteName
  }) : t(AI_RECOMMENDED_FOR_SITE_TRANSLATION_KEY, {
    planName
  });
  return /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    verticalAlign: "middle",
    gap: "4px",
    padding: "10px 0 10px 20px",
    borderRadius: "11px 11px 0 0",
    backgroundColor: AI_HAT_BACKGROUND,
    boxSizing: "border-box",
    dataHook: "ai-recommended-hat"
  }, /*#__PURE__*/React.createElement(SparkleIcon, {
    svgClassName: s.sparkle
  }), /*#__PURE__*/React.createElement(Text, {
    className: classNames(s.text, {
      [s.settled]: isSettled
    }),
    dataHook: "ai-recommended-hat-text"
  }, text));
};
//# sourceMappingURL=AiRecommendedHat.js.map